var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{staticClass:"mx-auto pa-0",attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }